import { CreateInvoiceProps, InvoiceDataProps } from 'entities/Invoice';

/**
 * Payload do POST /invoices a partir da prévia (POST /extract-invoices): a
 * prévia INTEIRA + o que só a tela decide (UC, GD, geração). Fonte única para o
 * modal de salvar e o upload em lote do admin — antes cada um listava os campos
 * e os dois esqueceram demand/reactiveEnergy (fatura do Grupo A gravada sem
 * demanda). O backend filtra pelas colunas da fatura (pickInvoiceFields).
 */
export const buildCreateInvoicePayload = (
  invoiceData: InvoiceDataProps,
  overrides: Pick<
    CreateInvoiceProps,
    'consumerUnitId' | 'hasFv' | 'monthGeneration'
  >
): CreateInvoiceProps => ({
  ...invoiceData,
  note: invoiceData.note ?? '',
  meterNumber: invoiceData.meterNumber || undefined,
  ...overrides,
});
